import modal from '../components/modal';
import ripple from '../components/ripple';
import toggle from '../components/toggle';

var timeout = null;

let checkValidationDisabled = () => {
  $('.accountNoCSR').on('keyup', 'input[name="domain"]', function () {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      let length = $('input[name="domain"]').val().length;
      let validationType = $('select[name="validationType"]');
      let approverEmail = $('select[name="approverEmail"]');
      let button = $('button[type="submit"]');

      if (length > 0) {
        validationType.removeAttr('disabled');
        approverEmail.removeAttr('disabled');
        button.removeAttr('disabled');
        validationType.trigger('change');
      } else {
        validationType.attr('disabled', true);
        approverEmail.attr('disabled', true);
        button.attr('disabled', true);
        validationType.trigger('change');
      }
    }, 1000);
  });
};

let checkValidationTypeLength = () => {
  let domainField = $('input[name="domain"]');
  if ($('.accountNoCSR').length && domainField.length) {
    let length = domainField.val().length;
    let validationType = $('select[name="validationType"]');
    let approverEmail = $('select[name="approverEmail"]');
    let button = $('button[type="submit"]');

    if (length > 0) {
      validationType.removeAttr('disabled');
      approverEmail.removeAttr('disabled');
      button.removeAttr('disabled');
    } else {
      validationType.attr('disabled', true);
      approverEmail.attr('disabled', true);
      button.attr('disabled', true);
    }
  }
};

export default {
  init() {
    // JavaScript to be fired on all pages
    modal();
    ripple();
    toggle();

    // SSL certificates
    checkValidationDisabled();
    checkValidationTypeLength();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js